import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex flex-col h-full bg-primary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 z-0 w-full h-full bg-no-repeat bg-cover background opacity-40" }, null, -1)
const _hoisted_3 = { class: "z-10 justify-center flex-1 flex-grow h-full" }
const _hoisted_4 = { class: "pb-2 pl-2 text-white" }

import Version from '@/components/UI/Version.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Version)
    ])
  ]))
}
}

})